import { observer } from 'mobx-react';
import React from 'react';
import classnames from 'classnames';

import './styles.scss';

type PropsType = {
    children?: React.ReactNode;
    className?: string
};

export const UiModalActions = observer(function UiModalActions({ children, className }: PropsType) {
    return <div className={classnames('ui-new-modal-actions', className)}>{children}</div>;
});
